/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { Button, Menu, Dropdown } from 'antd'
import { saveAs } from 'file-saver'
import { toXlsxColumns, toXlsxData, writeToExcel } from './xlsx-utils-excel'
import { formatData } from '@integec/grid-tools'
import moment from 'moment'

const userId = 'GADS'

export const getCellValue = (header, row) => {
  const cellValue = row[header.ident] === undefined ? '' : row[header.ident]
  let renderCell = cellValue
  if (header.dataGetter)
    renderCell = header.dataGetter({ rowData: row, header })
  // else if (header.dataFormatter)
  //   renderCell = header.dataFormatter({ value: cellValue })
  else
    renderCell = formatData({ header, value: row[header.ident], rowData: row })
  if (!renderCell) return ''
  return renderCell
}

class ExportComponentExcel extends React.Component {
  // const { headers, data, fileName, btnStyle, getData } = props
  constructor(props) {
    super(props)
    this.exportCSVData = this.exportCSVData.bind(this)
    this.exportData = this.exportData.bind(this)
    this.exportXLSData = this.exportXLSData.bind(this)
    // this.menu = this.menu.bind(this)
    this.handleExport = this.handleExport.bind(this)
    // this.getValue = this.getValue.bind(this)
    this.exportXLSXData = this.exportXLSXData.bind(this)
  }

  exportData(blob, type, fileName) {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob, { type })
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  exportCSVData() {
    const { headers, data, fileName, getData } = this.props
    const actData = getData ? getData() : data
    let dataStr = ''
    headers.forEach(header => {
      dataStr = `${dataStr},"${header.display}"`
    })
    dataStr = `${dataStr.substring(1)}\n`
    actData.forEach(row => {
      let rowStr = ''
      headers.forEach(header => {
        if (header.ident === 'modifier' || header.ident === 'modifiedDate') {
          rowStr = `${rowStr},"${
            header.ident === 'modifier'
              ? row.modificationInfo === undefined
                ? ''
                : row.modificationInfo.user
              : row.modificationInfo === undefined
              ? ''
              : moment(row.modificationInfo.modDate).format(
                  'MM/DD/YYYY HH:mm:ss'
                )
            // row.modificationInfo.modDate
          }"`
        } else {
          rowStr = `${rowStr},"${getCellValue(header, row)}"`
        }
      })
      rowStr = `${rowStr.substring(1)}\n`
      dataStr = `${dataStr}${rowStr}`
    })
    /* eslint-disable no-undef */
    const blob = new Blob([dataStr])
    /* eslint-disable no-undef */
    this.exportData(blob, 'text/csv', `${fileName}.csv`)
  }

  // eslint-disable-next-line no-unused-vars
  exportXLSData() {
    const { headers, data, fileName, getData } = this.props
    const actData = getData ? getData() : data
    let dataStr = `<?xml version="1.0" encoding="UTF-8"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns:html="http://www.w3.org/TR/REC-html40">
<Worksheet ss:Name="CognaLearn+Intedashboard">
<Table>
<Column ss:Index="1" ss:AutoFitWidth="0" ss:Width="110"/>
<Row>`

    headers.forEach(header => {
      dataStr = `${dataStr}
<Cell><Data ss:Type="String">${header.display}</Data></Cell>`
    })
    dataStr = `${dataStr}
</Row>`

    actData.forEach(row => {
      let rowStr = `
<Row>`
      headers.forEach(header => {
        if (header.ident === 'modifier' || header.ident === 'modifiedDate') {
          rowStr = `${rowStr}
          <Cell><Data ss:Type="${
            header.type === 'num' ? 'Number' : 'String'
          }">${
            header.ident === 'modifier'
              ? row.modificationInfo === undefined
                ? ''
                : row.modificationInfo.user
              : row.modificationInfo === undefined
              ? ''
              : row.modificationInfo.modDate
          }</Data></Cell>`
        } else {
          rowStr = `${rowStr}
<Cell><Data ss:Type="${
            row[header.ident] === undefined
              ? 'String'
              : header.type === 'num'
              ? 'Number'
              : 'String'
          }">${getCellValue(header, row)}</Data></Cell>`
        }
      })
      rowStr = `${rowStr}
</Row>`
      dataStr = `${dataStr}${rowStr}`
    })
    dataStr = `${dataStr}
</Table>
</Worksheet>
</Workbook>`
    const blob = new Blob([dataStr])
    this.exportData(blob, 'text/xls', `${fileName}.xls`)
  }

  exportXLSXData = async _ => {
    const { headers, data, fileName, getData } = this.props
    const exportHeader = [...headers]

    const columns = toXlsxColumns(exportHeader)
    // setSpinning(true)

    const actData = getData ? getData() : data
    const xlsxData = toXlsxData(actData, exportHeader)
    const worksheets = [
      {
        name: 'sheet1',
        columns,
        data: xlsxData,
        metaInfo: [],
        getBgColor: this.props.getBgColor,
        // colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheets, userId)

    // setSpinning(false)
    saveAs(fileBlob, fileName)
  }

  handleExport(e) {
    if (e.key === 'csv') this.exportCSVData()
    else if (e.key === 'xls') this.exportXLSXData()
  }

  render() {
    const { btnStyle } = this.props
    return (
      <Dropdown
        overlay={
          <Menu onClick={this.handleExport}>
            <Menu.Item key="csv">CSV</Menu.Item>
            <Menu.Item key="xls">XLS</Menu.Item>
          </Menu>
        }
      >
        <Button style={btnStyle} icon="export">
          Export
        </Button>
      </Dropdown>
    )
  }
}
export default ExportComponentExcel
